import {customAlphabet} from "nanoid";
import {roles} from "../assets/json/data";

function guid() {
    const nanoid = customAlphabet('123456789', 18);
    return nanoid();
}

function roleCheck(){
    let loginInfo = JSON.parse(sessionStorage.getItem("Admin-Data")||'{}')
    if(loginInfo.roleIds&&loginInfo.roleIds.length>0){
        let rolesData = JSON.parse(JSON.stringify(roles))
        loginInfo.roleIds.forEach(it=>{
            let temp = rolesData.find(role=>role.value == it)
            if(temp){
                temp.able = true
            }
        })
        return rolesData.filter(it=>it.able)
    }else{
        return []
    }
}

export default {
    guid,
    roleCheck
}



// WEBPACK FOOTER //
// ./src/utils/funcUtil.js